import { useDispatch } from 'react-redux';
import { Container, Row, Col, Button } from 'reactstrap';
import { actions } from '../../../context';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import EditMissionControlVersionModal from '../../Modals/MissionControl/EditMissionControlVersionModal';

const MissionControlDetails = () => {
    const dispatch = useDispatch();

    const [defaultMissionControlVersion, setDefaultMissionControlVersion] =
        useState();
    const [
        isEditMissionControlVersionModalOpen,
        setIsEditMissionControlVersionModalOpen,
    ] = useState(false);

    const refresh = () => {
        dispatch(
            actions.missionControl.fetchDefaultMissionControlVersion()
        ).then((res) => {
            setDefaultMissionControlVersion(res);
        });
    };

    useEffect(() => {
        refresh();
    }, [dispatch]);

    const SaveEditMissionControlVersionBehavior = (version) => {
        return dispatch(
            actions.missionControl.setDefaultMissionControlVersion(version)
        );
    };

    return (
        <Row className="sc-glass shadow text-light sc-rounded px-2 py-4 mb-4">
            <Col xs="12" className="text-light">
                <div className="box box-default">
                    <div className="box-header">
                        <h3 className="box-title border-bottom">
                            Default Mission Control Version
                        </h3>
                    </div>
                    <Container className="m-1">
                        <EditMissionControlVersionModal
                            isOpen={isEditMissionControlVersionModalOpen}
                            closeBehavior={() =>
                                setIsEditMissionControlVersionModalOpen(false)
                            }
                            currentMissionControlVersion={
                                defaultMissionControlVersion?.version
                            }
                            refreshBehavior={refresh}
                            saveBehavior={SaveEditMissionControlVersionBehavior}
                        />
                        <Row>
                            <b>Version:&nbsp;</b>
                            {defaultMissionControlVersion?.version
                                ? defaultMissionControlVersion?.version
                                : 'N/A'}
                            {defaultMissionControlVersion?.version && (
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    style={{ marginLeft: '10px' }}
                                    onClick={() =>
                                        setIsEditMissionControlVersionModalOpen(
                                            true
                                        )
                                    }
                                />
                            )}
                        </Row>
                        <Row>
                            <b>Release Date:&nbsp;</b>
                            {defaultMissionControlVersion?.releaseDate
                                ? moment
                                      .utc(
                                          defaultMissionControlVersion?.releaseDate
                                      )
                                      .local()
                                      .format('M/D/YYYY LT')
                                : 'N/A'}
                        </Row>
                        <Row>
                            <b>Description:&nbsp;</b>
                            {defaultMissionControlVersion?.description &&
                            defaultMissionControlVersion?.description !== ''
                                ? defaultMissionControlVersion?.description
                                : 'N/A'}
                        </Row>
                    </Container>
                </div>
            </Col>
        </Row>
    );
};

export default MissionControlDetails;
